import React from "react";
import { createComponent } from "@lit/react";
import { BeamSubscriptionManagement as _BeamSubscriptionManagement } from "./index";

export const BeamSubscriptionManagement = createComponent({
  tagName: _BeamSubscriptionManagement.tagName,
  elementClass: _BeamSubscriptionManagement,
  react: React,
  events: {},
});

export default BeamSubscriptionManagement; // default alias for use with async import utils like next/dynamic and react.lazy
